const PINNED_KEY = 'synoti_pinned';
const RECENT_KEY = 'synoti_recent';
const COLLAPSED_KEY = 'synoti_sidebar_collapsed';
const MAX_PINNED = 6;
const MAX_RECENT = 10;

export function getPinned() {
  try { return JSON.parse(localStorage.getItem(PINNED_KEY) || '[]'); }
  catch { return []; }
}

export function togglePinned(id) {
  const pinned = getPinned();
  const idx = pinned.indexOf(id);
  if (idx >= 0) { pinned.splice(idx, 1); }
  else { pinned.unshift(id); if (pinned.length > MAX_PINNED) pinned.pop(); }
  localStorage.setItem(PINNED_KEY, JSON.stringify(pinned));
  return pinned;
}

export function isPinned(id) {
  return getPinned().includes(id);
}

export function getRecent() {
  try { return JSON.parse(localStorage.getItem(RECENT_KEY) || '[]'); }
  catch { return []; }
}

export function pushRecent(id) {
  if (id === 'login') return;
  const recent = getRecent().filter(r => r !== id);
  recent.unshift(id);
  if (recent.length > MAX_RECENT) recent.pop();
  localStorage.setItem(RECENT_KEY, JSON.stringify(recent));
}

export function removeFromRecent(id) {
  const recent = getRecent().filter(r => r !== id);
  localStorage.setItem(RECENT_KEY, JSON.stringify(recent));
}

export function getSidebarCollapsed() {
  return localStorage.getItem(COLLAPSED_KEY) === '1';
}

export function setSidebarCollapsed(v) {
  localStorage.setItem(COLLAPSED_KEY, v ? '1' : '0');
}
